// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_82-0";
export var optionCard = "_82-1";